<template>

  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >

      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOW') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
                />
                <b-button
                  v-if="$ability.can(constants.action.permissionDebtorAdd, constants.resource.debtor)"
                  variant="primary"
                  :to="{name:'debtors-add'}"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_DEBTOR') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative resource-listing debtors"
          :items="fetchClients"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
          selectable
          @row-selected="onRowSelected"
        >

          <!-- Column: User -->
          <template #cell(user)="data">
            <b-media vertical-align="center">
              <b-link
                :to="{ name: 'debtor-view', params: { id: data.item.id } }"
                class="font-weight-bold d-block client-name"
              >
                <div>
                  <div>{{ data.item.name }}</div>
                  <small class="text-muted">@{{ data.item.username }}</small>
                  <small
                    v-if="data.item.clientName !== null"
                    class="text-muted"
                  ><br>{{ data.item.clientName }}</small>
                </div>
              </b-link>
            </b-media>
          </template>

          <!-- Column: Company -->
          <!-- <template
            v-if="1 < 0"
            #cell(company)="{data}"
          >
            {{ data.item.company }}
          </template> -->

          <!-- Column: Email -->
          <template #cell(email)="data">
            <div class="text-nowrap">
              <b-link
                :href="`mailto:${data.item.email}`"
                class="align-text-top"
              >
                {{ data.item.email }}
              </b-link>
            </div>
          </template>

          <!-- Column: Role -->
          <template #cell(type)="data">
            <b-link :to="{ name: 'debtor-view', params: { id: data.item.id } }">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{ data.item.debtor_type }}</span>
              </div>
            </b-link>
          </template>

          <!-- Column: Status -->
          <template #cell(login)="data">
            <b-link :to="{ name: 'debtor-view', params: { id: data.item.id } }">
              <b-badge
                pill
                :variant="`light-${resolveUserStatusVariant(data.item.login)}`"
                class="text-capitalize"
              >
                {{ data.item.login }}
              </b-badge>
            </b-link>
          </template>

          <!-- Column: Actions -->
          <!-- <template #cell(actions)="data">
            <b-dropdown
              v-if="$ability.can(constants.action.permissionUserEdit, constants.resource.user) || $ability.can(constants.action.permissionUserDelete, constants.resource.user)"
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="$ability.can(constants.action.permissionDebtorEdit, constants.resource.debtor)"
                :to="{ name: 'debtor-edit', params: { id: data.item.id } }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                :to="{ name: 'debtor-view', params: { id: data.item.id } }"
              >
                <feather-icon icon="EyeIcon" />
                <span class="align-middle ml-50">View</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="$ability.can(constants.action.permissionDebtorDelete, constants.resource.debtor)"
                @click="confirmText(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template> -->

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOW') }} {{ dataMeta.from }} {{ $t('DEBTIA_TO') }} {{ dataMeta.to }} {{ $t('DEBTIA_OF') }} {{ dataMeta.of }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalUsers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay></div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BLink,
  BBadge,
  // BDropdown, BDropdownItem,
  BPagination, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
// import UsersListFilters from './UsersListFilters.vue'
import constants from '@/app-configs/constants'
import axios from '@axios'
import useDebtorsList from './useDebtorsList'
import debtorStoreModule from '../debtorStoreModule'

export default {
  components: {
    // UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BBadge,
    // BDropdown,
    // BDropdownItem,
    BPagination,

    vSelect,
    BOverlay,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-debtor'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, debtorStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const {
      fetchClients,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      loader,
    } = useDebtorsList()

    const role = JSON.parse(localStorage.getItem('userData')).role[0]

    return {

      // Sidebar

      fetchClients,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      loader,
      constants,
      role,
    }
  },

  computed: {
    tableColumns() {
      const temp = [{ key: 'user', sortable: true, label: this.$t('DEBTIA_DEBTOR') },
        { key: 'email', sortable: false, label: this.$t('DEBTIA_EMAIL') },
        { key: 'type', sortable: false, label: this.$t('DEBTIA_DEBTOR_TYPE') },
        { key: 'login', sortable: false, label: this.$t('DEBTIA_LOGIN') },
        // { key: 'actions', label: this.$t('DEBTIA_ACTION') },
      ]

      if (this.role === 'super-admin') {
        temp.splice(
          1, 0, { key: 'company', sortable: false, label: this.$t('DEBTIA_COMPANY') },
        )
      }

      return temp
    },
  },

  created() {
    // this.actionColumn()
  },
  methods: {
    // actionColumn() {
    //   if (this.$ability.cannot(constants.action.permissionUserEdit, constants.resource.user) && this.$ability.cannot(constants.action.permissionUserDelete, constants.resource.user)) {
    //     this.tableColumns.splice(4)
    //   }
    // },
    onRowSelected(item) {
      this.selected = item
      this.$router.push(`/debtors/view/${item['0'].id}`)
    },
    confirmText(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios.post('/debtor/delete', { id })
            .then(response => {
              this.refetchData()
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
